const ReservationStatus = Object.freeze({
  BOOKED: 'BOOKED',
  CANCELED: 'CANCELED',
} as const);

export type ReservationStatus = (typeof ReservationStatus)[keyof typeof ReservationStatus];

export default ReservationStatus;
